export const name = "Mithilesh";
export const title = "Founder of this Repo";
export const email = "Mitumithilesh2@gmail.com";
export const github = "https://github.com/kingsmen732";
export const linkedin = "https://linkedin.com/in/mithilesh-babu";
export const twitter = "https://x.com/Its_mrleo732";
export const applemusic = "https://music.apple.com/us/album/blinding-lights-single/1488408555";
export const spotify = "https://open.spotify.com/playlist/0rp5i75Rt8WIXWdfzPpJXQ";
export const twitch = "https://www.twitch.tv/pewdiepie";
export const leetcode = "https://leetcode.com/kingsmen732/";
export const figma = "https://www.figma.com/@KIngsmen732";
export const discord = "https://discord.com/users/kingmen732";

export const skills = [
    "Robotics Ringleader",
    "Crazy Invention Creator",
    "High Creativity Connoisseur",
    "IoT Innovator",
    "Prototyping Mastery",
    "3D Design Dynamo",
];

export const resume = "./Resume.pdf"; //resume is working fine now
export const contactFormsparkId = ''



